import axios from 'axios';
import { NODE_BASE, LARAVEL_BASE } from './config';

axios.defaults.baseURL = NODE_BASE;
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
    r => r,
    (err) => {
        if (err?.response?.status === 401) {
        const returnUrl = encodeURIComponent(window.location.href);
        window.location.href = `${LARAVEL_BASE}/center-login?returnUrl=${returnUrl}`;
        }
        return Promise.reject(err);
    }
);

export default axios;
